import React, { Component, useCallback, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./Popup.module.scss";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import copy from "../../assets/copy/copy.json"

var classNames = require("classnames");

export default function MultiSelectModal(props) {
  const history = useHistory();
  let deselected = {}
  props.options.forEach((option) => {
    deselected[option.key] = false
  })
  props.selected?.forEach(option => deselected[option] = true)
  let count = Object.values(deselected).filter(e => e).length

  const [selected, setSelected] = useState(deselected)
  const [checkedCount, setCheckedCount] = useState(count)
  const [width, setWidth] = useState()

  const callbackRef = useCallback(node => {
    if (node) {
      setWidth(node.getBoundingClientRect().width)
    }
  })

  const onClose = () => {
    props.onClose();
  }

  const handleOnChange = (option) => {
    let current = selected;
    current[option] = !current[option]
    let currentCount = Object.values(current).filter(e => e).length
    let selectedOptions = Object.keys(current).filter(e => current[e])
    props.onChange(selectedOptions)
    setSelected(current)
    setCheckedCount(currentCount)
  }

  const handleClearAll = () => {
    let current = selected
    Object.keys(current).forEach(option => current[option] = false)
    props.onChange([])
    setSelected(current)
    setCheckedCount(0)
  }

  const handleSelectAll = () => {
    let current = selected
    Object.keys(current).forEach(option => current[option] = true)
    let selectedOptions = Object.keys(current)
    props.onChange(selectedOptions)
    setSelected(current)
    setCheckedCount(props.options.length)
  }

  if (props.isVisible) {
    document.body.classList.add("popup-mode");
  } else {
    document.body.classList.remove("popup-mode");
  }

  let CloseAlertControls = classNames(
    "tileBg2 " + styles.closeAlertControls,
    props.className,
    {
      [styles.visible]: props.isVisible,
    }
  );

  let DarkMask = classNames(styles.darkMask, props.className, {
    [styles.visible]: props.isVisible,
  });


  return (
    <div>
      <div
        className={CloseAlertControls}
        ref={callbackRef}
        style={{
          "zIndex": 14,
          "position": "absolute",
          "left": `${Math.max(props.position.right - width, 5)}px`,
          "top": `${props.position.bottom + 5}px`,
          "margin": "0",
          "transform": "none",
        }}
      >
        <div className={styles.content}>
          <div className={styles.spanButtons + " " + styles.titleRow}>
            <span>{`${props.secondaryListTitle} ${props.favourites.length}/10`}</span>
            <div className={styles.link} onClick={() => {
              history.push("/settings/profile");
            }}>Edit</div>
          </div>
          <form className={styles.filter}>
            <fieldset className={styles.scrollable}>
              <div>
                {props.favourites.map((e) => {
                  return (<div key={e.key} className={styles.listItem + " " + styles.multiSelectOverflow}>
                    <input
                      type="checkbox"
                      name="optionList"
                      key={e.key}
                      id={e.key}
                      value={e.value}
                      checked={selected[e.key]}
                      onChange={() => handleOnChange(e.key)}
                    ></input>
                    <label htmlFor={e.key}>{e.value}</label>
                  </div>)
                })}
              </div>
            </fieldset>
            <div className={styles.spanButtons + " " + styles.subtitleRow}>
              <span>{props.mainListTitle}</span>
            </div>
            <fieldset className={styles.scrollable}>
              <div>
                <div key="selectAll" className={styles.listItem + " " + styles.multiSelectOverflow}>
                  <input
                    type="checkbox"
                    name="optionList"
                    key={copy.myAvailabilityScreen.membersAvailability.selectAll}
                    id={copy.myAvailabilityScreen.membersAvailability.selectAll}
                    value={copy.myAvailabilityScreen.membersAvailability.selectAll}
                    checked={checkedCount === props.options.length}
                    onChange={handleSelectAll}
                  ></input>
                  <label key="selectAllLabel" htmlFor={copy.myAvailabilityScreen.membersAvailability.selectAll}>{copy.myAvailabilityScreen.membersAvailability.selectAll}</label>
                </div>
                {props.options.map((e) => {
                  return (<div key={e.key} className={styles.listItem + " " + styles.multiSelectOverflow}>
                    <input
                      type="checkbox"
                      name="optionList"
                      key={e.key}
                      id={e.key}
                      value={e.value}
                      checked={selected[e.key]}
                      onChange={() => handleOnChange(e.key)}
                    ></input>
                    <label htmlFor={e.key}>{e.value}</label>
                  </div>)
                })}
              </div>
            </fieldset>

          </form>
          <div className={styles.listItem + " " + styles.bottomLabels + " " + styles.bottomItem}>
            <div>Selected: {checkedCount}</div>
            <div className={styles.link} onClick={() => handleClearAll()}>Clear selected</div>
          </div>
        </div>
      </div>
      <div className={DarkMask} style={{ "zIndex": 13 }} onClick={onClose} />
    </div>
  );
}